class StringUtils {
  static toFilterText(text: string) {
    if (text) {
      const words: string[] = text.split(' ');
      if (words.length > 1) {
        for (let i = 0; i < words.length; i++) {
          words[i] = '"' + words[i] + '"';
        }
      }
      text = words.join(' ');
    }
    return text;
  }

  static fromFilterText(text: string) {
    if (text) {
      text = text.replaceAll('"', '');
      if (text.length > 30) {
        text = text.substring(0, 28) + '..';
      }
    }
    return text;
  }
}

export default StringUtils;
